import { gsap } from "gsap";
import scrollTrigger from "gsap/ScrollTrigger"

/**
 * # Effet Parrallax
 * L'effet du Parrallax est déterminée par l'attribut data-parrallax-depth
 * *exemple :*  ```<div data-parrallax-depth=1>object 1</div> <div data-parrallax-depth=2>object 2</div> ```
 */
class Parrallax {
    /**
     * 
     * @param {HTMLElement} el 
     */
    constructor(el) {
        this.DOM = el;
        this.ratio = this.DOM.dataset.parrallaxDepth === undefined ? 1 : this.DOM.dataset.parrallaxDepth
        this.parrallaxGsap();
    }


    parrallaxGsap() {
        gsap.registerPlugin(scrollTrigger)
        let offset = this.ratio * 10

        gsap.set(this.DOM, {
            yPercent: offset,
        })

        gsap.to(this.DOM, {
            yPercent: -offset,
            ease: "linear",
            scrollTrigger: {
                trigger: this.DOM,
                start: `top bottom+=${offset}px`,
                end: `bottop top-=${offset}px`,
                scrub: true
            },

        });
    }

    static bind() {
        const elements = document.querySelectorAll('[data-parrallax-depth]')

        elements && elements.forEach(element => {
            new Parrallax(element)
        })
    }
}

window.onload = Parrallax.bind()